module.exports = __webpack_public_path__ + "img/av-long-logo-black.70aac940.svg";